import productViewHtml from '../views/productView.component.html';
import Product from '../classes/product';
import TotalPrice from "../classes/totalPrice";

class ProductViewController {
    constructor($scope, $timeout, $sce, toast, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$sce = $sce;

        this.toast = toast;

        this.translate = translateService;

        this.product = new Product({}, null, this.translate);
        this.quantity = 0;

        this.prices = {};
        this.totalPrices = {};
        this.selectedVariant = null;
        this.calculatePriceTimeout = null;

        this.invalidFields = new Map();

        this.sent = false;
        this.saving = false;
        this.action = '';
        this.position = 0;

        this.$scope.trustedHtml = (plainText) => $sce.trustAsHtml(plainText);
    }

    addPosition() {
        this.position++;
    }

    $onInit() {
        this.rawProduct = JSON.parse(this.rawProduct);
        this.product = new Product(this.rawProduct, null, this.translate);

        if (this.product.variants) {
            this.selectedVariant = this.product.variants[0];
        }

        this.$scope.$watch(() => {
            return this.quantity
        }, (o,v) => {
            if(o !== v) {
                this.validateQuantity();
            }
        }, true);
    }

    calculateTotalPrice() {
        let quantity = typeof(this.quantity) === 'undefined' || parseInt(this.quantity) === 0 ? 1 : this.quantity;

        this.totalPrices = new TotalPrice();
        const priceSourceProduct = this.selectedVariant ? this.selectedVariant : this.product;

        // Get price from the product or the selected variant
        this.totalPrices.price = priceSourceProduct.prices.price;
        this.totalPrices.promo_price = priceSourceProduct.prices.promo_price;

        // Multiply price by quantity
        this.totalPrices.price = this.totalPrices.price * quantity;
        this.totalPrices.promo_price = this.totalPrices.promo_price * quantity;

        if (!this.selectedVariant) {
            // Calculate price for the base product
            this.totalPrices = this.product.getTotalPrice();
        } else {
            // Calculate price for the variant, its attributes and base product attributes
            this.totalPrices = this.selectedVariant.getTotalPrice();
            this.totalPrices.sum(this.product.getTotalAttributesPrice());
        }

        this.totalPrices.multiply(quantity);
    }

    sendEnquiry() {
        this.action = 'sendEnquiry';
        this.$timeout(() => {
            this.sendForm();
        }, 100);
    }

    saveConfiguration() {
        this.action = 'saveConfiguration';
        this.$timeout(() => {
            this.sendForm();
        }, 100);
    }

    sendForm() {
        this.sent = true;

        if (this.isValid) {
            this.saving = true;
            document.getElementById('product-form').submit();
        } else {
            this.toast.create({
                message: this.translate.t('found_errors_in_form'),
                className: 'alert-danger'
            });
        }
    }

    get isValid() {
        this.validateQuantity();

        return this.invalidAttributes === 0 && this.invalidFields.size === 0;
    }

    validateQuantity() {
        this.quantity <= 0 ? this.invalidFields.set('quantity', 1) : this.invalidFields.delete('quantity');
    }

    get invalidAttributes() {
        let invalid = 0;

        this.availableAttributes.forEach(productAttribute => {
            if (!productAttribute.validate()) {
                invalid++;
            }
        });

        return invalid;
    }

    get totalPrice() {
        this.calculateTotalPrice();
        return this.totalPrices;
    }

    get availableAttributes() {
        let attributesMap = new Map();

        if (this.product.attributes) {
            this.product.attributes.forEach(productAttribute => {
                attributesMap.set(productAttribute.attribute.id, productAttribute);
            });
        }

        if (this.selectedVariant) {
            this.selectedVariant.attributes.forEach(productAttribute => {
                attributesMap.set(productAttribute.attribute.id, productAttribute);
            });
        }
        return Array.from(attributesMap.values());
    }

    get selectedProduct() {
        return this.selectedVariant ? this.selectedVariant : this.product;
    }
}

let productViewComponent = {
    bindings: {
        rawProduct: '@',
        favorite: '<',
        messages: '<'
    },
    template: productViewHtml,
    controller: ProductViewController
}

export default productViewComponent;
